import React from 'react';
import { connect } from 'react-redux';

import { getCurrentOrders, getCurrentOrder } from '../../actions/auth';
import { setHistoryPanel } from '../../actions/panels';
import { ModalCloseButton } from '../common/ModalCloseButton';

import vestpa from '../../assets/images/vestpa---green.svg';
import success from '../../assets/images/success.svg';
import successWhite from '../../assets/images/success-white.svg';
import plated from '../../assets/images/plated-icon---green.svg';
import restaurant from '../../assets/images/restaurant-green.svg';
import progressLine from '../../assets/images/progressLine.svg';
import progressLineWhite from '../../assets/images/progressLineWhite.svg';
import closeIcon from '../../assets/images/close-icon.svg';
import rejectIcon from '../../assets/images/rejectIcon.svg';

//import { API_URL, CHANNEL_PREFIX, PUSHER_API_KEY, PUSHER_CLUSTER } from '../../config/constants';
//import axios from 'axios';

let interval;

class OrderStatus extends React.Component {

    constructor(props) {
        super(props);

        //console.log(this.props.currentOrder);
        
        /*
        this.pusherSubscribe = this.pusherSubscribe.bind(this);

        this.pusherClient = new Pusher(PUSHER_API_KEY, {
            cluster: PUSHER_CLUSTER,
            forceTLS: true,
            channelAuthorization: {
                customHandler: (channelName, socketId) => {

                    console.log("-- connectionData --");
                    console.log(channelName);
                    console.log(socketId);

                    try{
            
                        const token = window.localStorage.getItem('c2o.token');
                        let authData = {
                            token,
                            socket_id: channelName.socketId,
                            channel_name: channelName.channelName
                        };

                        axios.defaults.headers = {
                            'Access-Control-Allow-Origin': '*'
                        }

                        let result = axios.post(API_URL+'/broadcast/authorize', authData);
                        const { data } = result;
                        console.log('-- in onAuthorizer, returning ' + data?.auth);
                        return {
                            auth:data?.auth
                        }
                        
                    }catch (e){
                        console.log("-- Error get auth");
                        console.log(e);
                        return { auth: 'An error occured' };
                    }
                }
            }
            

        });
        */

    }

    componentDidMount(){

        interval = setInterval(() => {
            
            const token = window.localStorage.getItem('c2o.token');
            if (token) {
                this.props.dispatch(getCurrentOrders({ token }));
            }else{

                let orderKey = window.localStorage.getItem('currentOrderKey');
                if(orderKey){
                    this.props.dispatch(getCurrentOrder(orderKey, false));
                }

            }

        }, 30000);
        
    }

    /*
    pusherSubscribe(){

        let channelName = "private-"+CHANNEL_PREFIX+"order." + this.props.currentOrder.order_id;
        console.log("pusherSubscribe channelName: " + channelName);

        this.pusherClient.connection.bind( 'error', function( err ) {
            if( err.error.data.code === 4004 ) {
                console.log('Over limit!');
            }
        });

        this.channel = this.pusherClient.subscribe(channelName);

        this.channel.bind('update_status', function (data) {
            console.log("-- update status --");
            console.log(data.message);
        });
       
    }
    */

    renderStatus(){

        if(this.props.currentOrder.order_status == 'rejected'){

            return(
                <div className="statusWrapper">
                    <div className="statusContainerRejected">
                        <img src={successWhite} className="statusIconGreen" />
                        <img src={progressLineWhite} className="progressLineWhite" />
                        <img src={rejectIcon} className="statusIcon" />
                    </div>
                    <div className="textStatusContainerRejected">
                        <div className="textStatus">
                            <div>Order</div>
                            <div>Received</div>
                        </div>
                        <div className="textStatus">
                            <div>Order</div>
                            <div>Rejected</div>
                        </div>
                    </div>
                </div>
            );

        }else{

            if(this.props.currentOrder.order_type == 'delivery'){

                return(
                    <div className="statusWrapper">
                        <div className="statusContainer">
                            <img src={successWhite} className="statusIconGreen" />
                            {(this.props.currentOrder.delivery_status != 'received') && <img src={progressLine} className="progressLine" />}
                            {(this.props.currentOrder.delivery_status == 'received') && <img src={progressLineWhite} className="progressLineWhite" />}
                            {(this.props.currentOrder.delivery_status == 'received') && <img src={restaurant} className="statusIcon" />}
                            {(this.props.currentOrder.delivery_status != 'received') && <img src={successWhite} className="statusIconGreen" />}
                            {(this.props.currentOrder.delivery_status == 'picked_up' || this.props.currentOrder.delivery_status == 'completed') && <img src={progressLine} className="progressLine" />}
                            {(this.props.currentOrder.delivery_status == 'confirmed' || this.props.currentOrder.delivery_status == 'received') && <img src={progressLineWhite} className="progressLineWhite" />}                        
                            {(this.props.currentOrder.delivery_status == 'received' || this.props.currentOrder.delivery_status == 'confirmed') && <img src={vestpa} className="statusIcon" />}
                            {(this.props.currentOrder.delivery_status == 'completed' || this.props.currentOrder.delivery_status == 'picked_up') && <img src={successWhite} className="statusIconGreen" />}
                            {(this.props.currentOrder.delivery_status == 'completed') && <img src={progressLine} className="progressLine" />}
                            {(this.props.currentOrder.delivery_status != 'completed') && <img src={progressLineWhite} className="progressLineWhite" />}                        
                            {(this.props.currentOrder.delivery_status != 'completed') && <img src={plated} className="statusIcon" />}
                            {(this.props.currentOrder.delivery_status == 'completed') && <img src={successWhite} className="statusIconGreen" />}
                        </div>
                        <div className="textStatusContainer">
                            <div className="textStatus">
                                <div>Order</div>
                                <div>Received</div>
                            </div>
                            <div className="textStatus">
                                <div>Order</div>
                                <div>Confirmed</div>
                            </div>
                            <div className="textStatus">
                                <div>Order</div>
                                <div>On The Way</div>
                            </div>
                            <div className="textStatus">
                                <div>Order</div>
                                <div>Complete</div>
                            </div>
                        </div>
                    </div>

                );
    
            }else{

                return(
                    <div className="statusWrapper">
                        <div className="statusContainerPickup">
                            <img src={successWhite} className="statusIconGreen" />
                            {(this.props.currentOrder.delivery_status != 'received') && <img src={progressLine} className="progressLine" />}
                            {(this.props.currentOrder.delivery_status == 'received') && <img src={progressLineWhite} className="progressLineWhite" />}
                            {(this.props.currentOrder.delivery_status == 'received') && <img src={restaurant} className="statusIcon" />}
                            {(this.props.currentOrder.delivery_status != 'received') && <img src={successWhite} className="statusIconGreen" />}
                            {(this.props.currentOrder.delivery_status == 'picked_up' || this.props.currentOrder.delivery_status == 'completed') && <img src={progressLine} className="progressLine" />}
                            {(this.props.currentOrder.delivery_status == 'confirmed' || this.props.currentOrder.delivery_status == 'received') && <img src={progressLineWhite} className="progressLineWhite" />}                        
                            {(this.props.currentOrder.delivery_status != 'completed') && <img src={plated} className="statusIcon" />}
                            {(this.props.currentOrder.delivery_status == 'completed') && <img src={successWhite} className="statusIconGreen" />}
                        </div>
                        <div className="textStatusContainerPickup">
                            <div className="textStatus">
                                <div>Order</div>
                                <div>Received</div>
                            </div>
                            <div className="textStatus">
                                <div>Order</div>
                                <div>Confirmed</div>
                            </div>
                            <div className="textStatus">
                                <div>Order</div>
                                <div>Complete</div>
                            </div>
                        </div>
                    </div>

                );
    
            }
    
        }

    }

    render() {
        
        if(this.props.currentOrder.id != '0'){

            return (
            
                <div>
                    <div className="close-button">
                        <ModalCloseButton 
                            clickAction={() =>{
                                clearInterval(interval);
                                this.props.dispatch(setHistoryPanel('list'));
                            }} 
                        />
                    </div>
                    <div className="innerContainer">
                        <img src={success} className="successIcon"/>
                        <h3 className="headerText">Yes!</h3>
                        <h3 className="headerText">Your <label className="redText">Eats</label> have</h3>
                        <h3 className="headerText">been received...</h3>                        
                        <div className="orderNumber">Order Number # {this.props.currentOrder.order_id}</div>
                        {(this.props.currentOrder.delivery_status == 'received') && <div className="statusMessage">Thank you for your order. We are waiting for {this.props.currentOrder.restaurant_name} to confirm your order.</div>}
                        {(this.props.currentOrder.order_type == 'delivery' && this.props.currentOrder.delivery_status == 'confirmed') && <div className="statusMessage">{this.props.currentOrder.restaurant_name} is preparing your order and is responsible for its accuracy and packaging. Check your email receipt for an estimated pickup/delivery time.</div>}
                        {(this.props.currentOrder.order_type == 'delivery' && this.props.currentOrder.delivery_status == 'picked_up' && this.props.currentOrder.tracking_url == null) && <div className="statusMessage">Your order is on the way!</div>}
                        {(this.props.currentOrder.order_type == 'delivery' && this.props.currentOrder.delivery_status == 'picked_up' && this.props.currentOrder.tracking_url != null) && <div className="statusMessage">Your order is on the way! <a href={this.props.currentOrder.tracking_url} target="_blank" className="linkText">Track it live.</a></div>}
                        {(this.props.currentOrder.order_type == 'delivery' && this.props.currentOrder.delivery_status == 'completed') && <div className="statusMessage">Thank you for Chewsing Local! We hope you enjoyed.</div>}
                        {(this.props.currentOrder.order_type == 'pickup' && this.props.currentOrder.delivery_status == 'completed' && this.props.currentOrder.pickup_time_formatted != null) && <div className="statusMessage">Thank you for Chewsing Local! Your order will be ready for pickup at {this.props.currentOrder.pickup_time_formatted}.</div>}
                        {this.renderStatus()}
                    </div>
                </div>
                
            );
    
        }else{
            return (<div></div>);
        }
        
    }

}

const mapStateToProps = (state) => {
    return {
        currentOrder: state.auth.currentOrder
    };
};

export default connect(mapStateToProps)(OrderStatus);